/**
 * Files from `public/`. Vite copies them next to the bundle; in production
 * that is under `/v2/`, locally it is `/`.
 */
export function publicUrl(filePath: string): string {
  return `${import.meta.env.BASE_URL}${filePath.replace(/^\//, '')}`;
}
